import Immutable, { Map, List, fromJS } from 'immutable';
import {
  DEFAULT_EXCEPTION_TYPE_LIST_ANDROID,
  HANG_EXCEPTION_TYPE_LIST_OPTIONS,
  ISSUE_LIST_ROUTE_REGEX,
  JANK_EXCEPTION_TYPE_LIST_OPTIONS,
  METRICKIT_CRASH_EXCEPTION_TYPE_LIST_OPTIONS,
  METRICKIT_CPU_EXCEPTION_TYPE_LIST_OPTIONS,
  METRICKIT_DISK_EXCEPTION_TYPE_LIST_OPTIONS,
  AEXIT_CRASH_EXCEPTION_TYPE_LIST_OPTIONS,
  AEXIT_ANR_EXCEPTION_TYPE_LIST_OPTIONS,
  PLATFORM_ID
} from 'utils/constants';
import { handleActions } from 'redux-actions';
import i18n from 'i18n.js';
import moment from 'moment';
import { isAndroid, isLinux, isMobile, isPcOrLinux, isPlaystation } from 'utils/platform';
import { compareBundleId, getIssueDetailUrlPrefix, getUserId, getVersionRangeString } from 'utils/helper';
import { message } from 'antd';
import {
  ANDROID_EXCEPTION_TYPE_LIST_OPTIONS,
  IOS_EXCEPTION_TYPE_LIST_OPTIONS,
  ANR_EXCEPTION_TYPE_LIST_OPTIONS,
  ERROR_EXCEPTION_TYPE_LIST_OPTIONS,
} from 'utils/constants';
import { getNickName, parseSearch } from 'utils/helper';
import {
  LOCATION_CHANGE,
  RESET_SEARCH_PARAMS,
  CHANGE_EXCEPTION_TYPE_OPTIONS,
  GETSOLUTIONINFO_GET_SUCC,
  TAPD_SUBMIT_SUCC,
} from 'store/actions';
import { initialState, initialSearchParams } from './issueInitialState';
import XLSX from 'xlsx';
import {getReportCategoryByExceptionTypeInt} from "utils/constants/exception-type-int";
import { isNotNullish } from 'utils/nullish';
import uniqBy from 'lodash.uniqby';
import { CustomKvUtil } from 'utils/custom-kv';
import { TapdUtil } from "utils/tapd-util";
import { ze } from 'utils/zhEn';
import { CrashAttachmentFileType, CrashAttachmentUtil } from 'utils/crash-attachment-util';
import { CrashUtil } from 'utils/api/crash';
import { ExceptionCategoryUtil } from 'utils/exception-category';
import uniq from 'lodash/array/uniq';
import { DataDetailUtil } from 'components/exception/issue/DataDetail';
import { StackUtil } from 'utils/stack';
import { ReduxActionType } from 'reducers/redux-action-type';
import { getAllInOneReduxState } from 'index';
import { MinidumpSymbolType } from 'utils/constants/minidump-symbol-type';
import { RegisterInfoUtil } from 'components/exception/issue/RegisterInfo/RegisterInfo';
import IssueCrashSearchUtil from 'utils/IssueCrashSearchUtil';

function handleFetchIssueFail(state) {
  return state.update('issueList', (issueList) => issueList.clear())
    .set('numFound', 0)
    .set('statusCode', -1);
}

function createExcel(data,title){
      const { utils } = XLSX;
      var ws_name = "sheet1";
      const wb= utils.book_new();
      /* make worksheet */
      var ws = utils.aoa_to_sheet(data);
      /* Add the worksheet to the workbook */
      XLSX.utils.book_append_sheet(wb, ws, ws_name);
      XLSX.writeFile(wb, title);
    }

function initLogStatus(state, logType = 'sysLog') {
  return state.update('current', (issue) => issue
    .set('logLevel', 'verbose')
    .set('logType', logType)
    .set('logKey', '')
    .set('stackType', 'retrace')
    .set('isShowOtherThread', false));
}

function initTab(state) {
  return state.update('current', (issue) => issue.set('tab1', '').set('tab2', ''));
}

// 统一生成更多线程附件结构，供PC/Linux和PS5解析结果复用。
function makeOtherThread(fileName, content) {
  return {
    fileName,
    content,
    fileType: CrashAttachmentFileType.OTHER_THREAD,
  };
}

// PC/Linux其他线程以Thread开头的标题行分段，保留原有解析规则。
function parsePcOtherThreads(otherThreadsText) {
  const splitRes = String(otherThreadsText || '').split(/^(Thread.+)$/im);
  const otherThreads = [];
  for (let i = 1; i < splitRes.length; i += 2) {
    const fileName = splitRes[i];
    const content = splitRes[i + 1].trim();
    otherThreads.push(makeOtherThread(fileName, content));
  }

  return otherThreads;
}

// 需求背景：PS5上报的otherBreakpadCosKey有内容，但解压后不使用PC/Linux的Thread标题格式，
// 旧解析会得到空数组，导致详情页点击“展开其他线程”后无内容展示。
// PS5其他线程格式是“线程名(tid)”占一行，后续缩进行是该线程堆栈。
function parsePlaystationOtherThreads(otherThreadsText) {
  const otherThreads = [];
  let currentFileName = '';
  let currentContentLines = [];

  const saveCurrentThread = () => {
    const content = currentContentLines.join('\n').trim();
    if (currentFileName && content) {
      otherThreads.push(makeOtherThread(currentFileName, content));
    }
  };

  String(otherThreadsText || '').replace(/\r\n?/g, '\n').split('\n').forEach((line) => {
    if (!line.trim()) {
      if (currentFileName) {
        currentContentLines.push(line);
      }
      return;
    }

    if (!/^\s/.test(line)) {
      saveCurrentThread();
      currentFileName = line.trim();
      currentContentLines = [];
      return;
    }

    if (currentFileName) {
      currentContentLines.push(line);
    }
  });

  saveCurrentThread();

  return otherThreads;
}

export default handleActions({
  [ReduxActionType.setQueryIssueListResult]: (state, action) => {
    if (!action.response) {
      return handleFetchIssueFail(state);
    }
    const { numFound, issueList, queryInaccurateReason } = action.response;
    return state.update('issueList', (domain) => domain.clear().mergeDeep(issueList))
      .set('numFound', numFound)
      .set('queryInaccurateReason', queryInaccurateReason)
      .set('loading', false)
      .set('statusCode', 0);
  },

  [ReduxActionType.fillIssueVersions]: (state, action) => {
    const { issueIdToVersionList: patch } = action;
    if (!patch) {
      return state;
    }

    const patchIssueIdList = Object.keys(patch);
    let issueIdToVersionList = {
      ...state.get('issueIdToVersionList'),
      ...patch,
    };
    let recentVersionListCachedIssueIdList = [
      ...state.get('recentVersionListCachedIssueIdList'),
      ...patchIssueIdList,
    ];
    const MAX_RECENT_ISSUE_IDS = 300; // 缓存上限
    // 如果recentVersionListCachedIssueIdList长度超过上限，移除最老的，并且从issueIdToVersionList这个object里面也移除掉
    // 如果缓存ID列表超过上限，移除最老的部分
    if (recentVersionListCachedIssueIdList.length > MAX_RECENT_ISSUE_IDS) {
      // 计算需要移除的数量
      const removeCount = recentVersionListCachedIssueIdList.length - MAX_RECENT_ISSUE_IDS;
      // 获取需要移除的最老的issueId列表
      const removedIssueIds = recentVersionListCachedIssueIdList.slice(0, removeCount);

      // 从缓存列表中移除最老的部分
      recentVersionListCachedIssueIdList = recentVersionListCachedIssueIdList.slice(removeCount);

      // 从版本映射对象中移除对应的条目
      removedIssueIds.forEach(issueId => {
        delete issueIdToVersionList[issueId];
      });
    }

    return state.set('issueIdToVersionList', issueIdToVersionList)
      .set('recentVersionListCachedIssueIdList', recentVersionListCachedIssueIdList);
  },

  [ReduxActionType.setQueryIssueListDownloadResult]: (state, action) => {
    const { exceptionCategoryList: categoryListStr, exceptionTypeList, platformId } = action.params;
    let filenamePrefix = '';
    if (categoryListStr) {
      const categoryList = categoryListStr.split(',');
      filenamePrefix = categoryList.map(x => ExceptionCategoryUtil.toI18n(x, platformId)).join(',');
    } else if (exceptionTypeList) {
      const typeList = exceptionTypeList.split(',');
      const queryCategories = uniq(typeList.map(x => ExceptionCategoryUtil.fromExceptionType(x)));
      filenamePrefix = queryCategories.map(x => ExceptionCategoryUtil.toI18n(x, platformId)).join(',');
    }
    const {  issueList } = action.response;
    const title = ze(`${filenamePrefix}问题列表.xlsx`, `${filenamePrefix} Issue List.xlsx`);
    const header = [
      i18n.t('issueCrashFilterKey.issueId'),
      i18n.t('issueCrashFilterKey.errorType'),
      i18n.t('REPORTDETAIL.expMessage'),
      i18n.t('REPORTDETAIL.首行关键堆栈'),
      i18n.t('issueCrashFilterKey.version'),
      i18n.t('EXCP_OVERVIEW.occurNum'),
      i18n.t('EXCP_OVERVIEW.userNum'),
      i18n.t('issueCrashFilterKey.issueTag'),
      i18n.t('issueCrashFilterKey.issueFirstUploadTime'),
      ze('平台链接', 'Web URL'),
      ze('关联缺陷单标题', 'Bound Tapd Issue Titie'),
      ze('关联缺陷单链接', 'Bound Tapd Issue URL'),
    ];
    const body = issueList.map(item=>{
      let tagStr = [];
      if(item.tagList){
        tagStr = item.tagList.map(item=>{
          return item.tagName
        });
      }
      const issueDetailUrlPrefix = getIssueDetailUrlPrefix(getReportCategoryByExceptionTypeInt(item.issueExceptionType));
      const pureVersions = Array.isArray(item.issueVersions)
        ? item.issueVersions.map(x => x.version)
        : [];

        const bugs = item.bugs;
        const tapdBugInfo = bugs && bugs[0];
        const { workspaceId, id: bugId, commercialTapd } = tapdBugInfo || {};

        const bugUrl = TapdUtil.makeBugUrl(tapdBugInfo, action.params.teamType);

        return [
          item.issueId,
          item.exceptionName,
          item.exceptionMessage,
          item.keyStack,
          getVersionRangeString(pureVersions),
          item.count,
          item.imeiCount,
          item.tagInfoList.map((num) => num.tagName).join(","),
          moment(item.firstUploadTime,'YYYY-MM-DD HH:mm:ss SSS').format('YYYY-MM-DD HH:mm:ss'),
          `${window.location.protocol}//${window.location.host}/${issueDetailUrlPrefix}/${action.params.appId}/${item.issueId}?pid=${action.params.platformId}`,
          item.bugs && item.bugs.length > 0 ? item.bugs[0].title : '',
          bugUrl,
        ];
      });
    const downloadedIssues = body.length;
    const data = [header,...body];
    createExcel(data,title);
    if (downloadedIssues < 1000) {
      message.success(ze(`已成功下载 ${downloadedIssues} 条问题数据`, `${downloadedIssues} issue(s) have been downloaded.`));
    } else {
      message.success(ze(`已成功下载 ${downloadedIssues} 条问题数据 （最大支持下载 ${1000} 条）`, `${downloadedIssues} (Limit reached) issue(s) have been downloaded.)`));
    }
    return state
  },

  ISSUES_LIST_FAIL: handleFetchIssueFail,

  CHECK_ISSUE: (state, action) => { // 选中/取消问题列表项
    const {
      issue, checkAll, checked, multi,
    } = action;
    return state.update('issueList', (issueList) => issueList.map((oneIssue) => {
      if (checkAll) {
        return oneIssue.set('checked', checked);
      }
      const targetIssue = multi ? oneIssue : oneIssue.set('checked', false);
      return targetIssue.get('issueId') === issue.get('issueId') ? targetIssue.set('checked', checked) : targetIssue;
    }));
  },
  // 首次获取crash的详细信息；这里有约束条件，retrashCrashDetail和crashDetail都已经是设定好的。
  GET_CRASH_DETAIL_SUCC: (state, action) => {
    const { params, response: { retraceCrashDetail: crashDetail, callStack: originDetail } } = action;
    return state.update('issueList', (issueList) => issueList.map((issue) => {
      if (issue.get('issueId') === params.issueId) {
        return issue.merge({
          detailInfo: action.response,
          crashDetail: crashDetail ? crashDetail.split(/\n|\r/g).filter((item) => !!item) : [],
          originDetail: originDetail ? originDetail.split(/\n|\r/g).filter((item) => !!item) : [],
          showDetail: true,
          offsetTop: params.offsetTop,
        });
      } else {
        return issue.get('showDetail') ? issue.set('showDetail', false) : issue;
      }
    }));
  },


  GET_ISSUE_INFO_SUCC: (state, action) => handleGetIssueInfoSuccess(state, action),

  GET_ISSUE_INFO_FROM_SHARE_LINK_SUCC: (state, action) => handleGetIssueInfoSuccess(state, action),

  SET_ISSUE_LIST: (state, action) => {
    return state.update('issueList', (x) => x.clear().mergeDeep(action.issueList));
  },

  GET_CRASH_DOC_FROM_SHARE_LINK_SUCC: (state, action) => handleGetCrashDoc(state, action),

  saveCrashDocToReduxState: (state, action) => {
    const newState = handleGetCrashDoc(state, action);
    const { crashMap } = action.response || {};
    return saveResponeToCurrent(newState, 'detailInfo', CrashUtil.makeRefinedCrashMap(crashMap));
  },

  resetCrashRelatedInfoInCurrentIssue: (state, action) => {
    const patch = {
      attachList: null,
      attachCustomKvList: null,
      attachAllKvList: null,
      // 自定义kv合并需求：handleGetCrashDoc（ES）和handleGetCrashAttachment（COS）两个reducer的
      // 触发顺序不确定，因此各自的解析结果需要先存到下面这几个"_"开头的中间字段里，
      // 再由两个reducer各自读取对方已存入的中间结果做合并，写回attachCustomKvList/attachAllKvList。
      // 这样无论两者谁先谁后触发，最终合并结果都是完整、正确的。详见下方mergeEsAndCosKvList的注释。
      // 这几个字段仅供上面两个reducer内部合并使用，其他地方不应该直接读取。
      _esCustomKvList: null,
      _cosAllKvList: null,
      _cosCustomKvList: null,
      appDetailCrashInfo: null,
      crashDoc: undefined,
      detailInfo: undefined,
      extraFile: null,
      isShowOtherThread: false,
      otherThread: null,
      androidNativeOtherThreadAttachInfoList: null,
      // 卡顿采样堆栈（jankV2_samples.json）解析结果
      jankSampleStackInfo: null,
      luaCppStack: '',
      luaLinesFragmentList: null,
      isShowingLuaCppStack: false,
      hasAndroidTraceOtherThreads: false,
      userLogs: null,
      sysLogs: null,
      isShowingMinidumpStack: false,
      isShowingRetracedAnrTrace: false,
      pcModuleInfoList: null,
      pcAllModuleInfoLines: null,
      pcHasWineModule: false,
      pcRegisterInfoFetching: false,
      pcRegisterInfoLines: null,
      minidumpRegisterInfoParseResult: undefined,
      minidumpDetailStackMemoryInfoList: undefined,
      nonMinidumpDetailStackMemoryInfoList: undefined,
      pcStackMemoryLines: undefined,
      retracedAnrTrace: null,
      lastFetchedPcSoInfoCrashId: undefined,
      jankRelatedReportEsMapList: undefined,
    };
    return state.update('current', current => current.merge(patch));
  },

  resetAllDataInCurrentIssue: (state, action) => {
    state = state.set('current', new Map());
    state = initTab(state);
    state = initLogStatus(state);
    return state;
  },

  updateReduxIssueState: (state, action) => {
    const { data } = action;
    return state.merge(data);
  },

  handleQueryAppDetailCrash: (state, action) => handleGetCrashAttachment(state, action),

  GET_CRASH_ATTACHMENT_FROM_SHARE_LINK_SUCC: (state, action) => handleGetCrashAttachment(state, action),

  // 新添加的重还原的解析接口请求
  RELOAD_CRASH_ATTCHMENT_SUCC: (state, action) => test(state, action),

  /**
   * 切换显示问题详情
   */
  toggle_crash_detail: (state, action) => {
    const payloadIssue = action.payload;
    return state.update('issueList', (issueList) => issueList.map((issue) => {
      if (issue.get('issueId') === payloadIssue.get('issueId')) {
        return issue.set('showDetail', !issue.get('showDetail'));
      }
      return issue.get('showDetail') ? issue.delete('showDetail') : issue;
    }));
  },

  ISSUEOPTIONS_GET_SUCC: (state, action) => handleGetIssueOptions(state, action),

  GETSELECTOR_GET_SUCC: (state, action) => handleGetSelector(state, action),

  [LOCATION_CHANGE]: (state, action) => {
    const { location } = action.payload;
    const { pathname } = location;
    const query = parseSearch(location);
    if (isMatchIssueRoute(pathname)) {
      return state.update('searchParams', (searchParams) => {
        return Object.keys(query).length > 1 ? searchParams.merge(query) : initialSearchParams;
      })
        .updateIn(['searchParams', 'exceptionTypeList'], () => query.exceptionTypeList || '')
        .updateIn(['searchParams', 'pcHangSplit'], () => query.pcHangSplit || '');
    }
    return state;
  },

  updateReduxIssueSearchParams: (state, action) => {
    const query = action.payload;
    return state.update('searchParams', (searchParams) => {
      return searchParams.merge(query);
    });
  },

  CHANGE_TAB: (state, action) => state.update('current', (issue) => issue.set(`tab${action.tab}`, action.value)),

  INITIAL_TAB: (state) => initTab(state),

  NOTELIST_GET_SUCC: (state, action) => state.update('current', (issue) => issue.set('noteList', new List(action.response))),

  NOTELIST_ADD_REQ: (state) => state.update('current', (issue) => issue.set('noteDisabled', true)),

  NOTELIST_ADD_SUCC: (state, action) => state.update('current', (issue) => {
    return issue.update('noteList', (noteList) => noteList.unshift(action.params)).set('noteDisabled', false);
  }),

  CHANGE_LOG: (state, action) => state.update('current', (issue) => issue.set('logType', action.logType)),

  CHANGE_LEVEL: (state, action) => state.update('current', (issue) => issue.set('logLevel', action.level)),

  INIT_LOG_STATUS: (state, action) => initLogStatus(state, action.logType || 'sysLog'),

  CHANGE_KEY: (state, action) => state.update('current', (issue) => issue.set('logKey', action.value)),

  TAG_ADD_SUCC: (state, action) => handleAddOrDelTagSucc(state, action),
  TAG_DEL_SUCC: (state, action) => handleAddOrDelTagSucc(state, action),

  STACK_TYPE_CHANGE: (state, action) => saveResponeToCurrent(state, 'stackType', action.stackType),

  IS_SHOW_OTHER_THREAD: (state, action) => saveResponeToCurrent(state, 'isShowOtherThread', action.isShow),

  CHANGE_STATE_SUCC: changeStateSucc,

  [TAPD_SUBMIT_SUCC]: changeStateSucc,

  CHANGE_ISSUE_TREND_TAG: (state, action) => state.update('current', (issue) => issue.set('issueTrendTag', action.tagName)),

  CHANGE_ISSUE_TREND_VERSION: (state, action) => state.update('current', (issue) => issue.set('issueTrendVersion', action.version)),
  CHANGE_ISSUE_TREND_COUNTRY_LIST: (state, action) => state.update('current', (issue) => issue.set('issueTrendCountryList', action.countryList)),

  /**
   * 重置问题列表搜索条件
   */
  [RESET_SEARCH_PARAMS]: (state, action) => {
    const { pid, exceptionType } = action.payload;
    return changeExceptionOptionsAndTypeList(state.update('searchParams', () => initialSearchParams), pid, exceptionType);
  },

  [CHANGE_EXCEPTION_TYPE_OPTIONS]: (state, action) => {
    const { pid, exceptionType } = action.payload;
    return changeExceptionOptionsAndTypeList(state, pid, exceptionType);
  },

  [GETSOLUTIONINFO_GET_SUCC]: (state, action) => {
    return state.update('current', (issue) => issue.set('solution', action.response.datas));
  },

  QUERY_ISSUE_TREND_START: (state, action) => state.set('issueListTrendLoading', true),

  QUERY_ISSUE_TREND_END: (state, action) => state.set('issueListTrendLoading', false),

  setIssueTrendData: (state, action) => state.update('current', (issue) => {
    const { trendList, jankTrendList } = action.payload;
    return issue.set('issueTrendData', trendList || [])
      .set('issueJankTrendData', jankTrendList || []);
  }),

  setIssueTrendAccessDeviceTrendData: (state, action) => state.update('current', (issue) => issue.set('issueTrendAccessDeviceTrendData', action.payload)),

  // setIssueIdToDailyTrendList: (state, action) => state.set('issueIdToDailyTrendList', action.payload),

  patchIssueIdToDailyTrendList: (state, action) => state.update('issueIdToDailyTrendList', x => ({ ...x, ...action.payload })),

  // setIssueIdToHourlyTrendList: (state, action) => state.set('issueIdToHourlyTrendList', action.payload),

  patchIssueIdToHourlyTrendList: (state, action) => state.update('issueIdToHourlyTrendList', x => ({ ...x, ...action.payload })),

  patchIssueIdToDailyTrendListLastFetchMillis: (state, action) => state.update('issueIdToDailyTrendListLastFetchMillis', x => ({ ...x, ...action.payload })),

  patchIssueIdToHourlyTrendListLastFetchMillis: (state, action) => state.update('issueIdToHourlyTrendListLastFetchMillis', x => ({ ...x, ...action.payload })),

  patchIssueIdToAiReason: (state, action) => state.update('issueIdToAiReason', x => ({ ...x, ...action.payload })),

  patchCurrentIssueInfo: (state, action) => state.update('current', x => x.merge(action.payload),
  ),

  PARSE_AND_SAVE_PC_MODULE_INFO: (state, action) => {
    const reduxState = getAllInOneReduxState();
    const { appId, pid } = reduxState.app.get('current').toJS();

    const { payload } = action;
    let { text, crashId } = payload;
    text = (text || '').trim();
    const SYMBOL_MODULE_INFO_HEADER = 'Symbol Module infos:';
    const ALL_MODULE_INFO_HEADER = 'All Module infos:';
    const STACK_MEMORY_INFO_HEADER = 'Stack Memory Infos:';
    const DETAIL_STACK_MEMORY_INFO_JSON_HEADER = 'JSON Stack contents:';
    const ALL_HEADERS = [
      SYMBOL_MODULE_INFO_HEADER,
      ALL_MODULE_INFO_HEADER,
      STACK_MEMORY_INFO_HEADER,
      DETAIL_STACK_MEMORY_INFO_JSON_HEADER,
    ];

    // TODO: 适配后台JSON Stack contents的内容后面漏了个换行导致后面JSON parse失败的问题。
    // TODO: 这个需要后台解决了之后，跑两个月数据然后再把这个逻辑去掉。2024-10-28之后可以去掉。
    text = text.replace(STACK_MEMORY_INFO_HEADER, '\n' + STACK_MEMORY_INFO_HEADER);

    let symbolModuleLines = [];
    const allModuleLines = DataDetailUtil.filterSectionLinesByHeaderList(
      text, [ALL_MODULE_INFO_HEADER], ALL_HEADERS, false)
      .slice(1);
    const stackMemoryLines = DataDetailUtil.filterSectionLinesByHeaderList(
      text, [STACK_MEMORY_INFO_HEADER], ALL_HEADERS, false)
      .slice(1);

    if (text.includes(SYMBOL_MODULE_INFO_HEADER)) {
      symbolModuleLines = DataDetailUtil.filterSectionLinesByHeaderList(
        text, [SYMBOL_MODULE_INFO_HEADER], ALL_HEADERS, false)
        .slice(1);
    } else {
      symbolModuleLines = text.split('\n');
    }

    const detailStackMemoryInfoJson = DataDetailUtil.filterSectionLinesByHeaderList(
      text, [DETAIL_STACK_MEMORY_INFO_JSON_HEADER], ALL_HEADERS, false)
      .slice(1)[0];
    let minidumpDetailStackMemoryInfoList = [];
    try {
      if (detailStackMemoryInfoJson) {
        minidumpDetailStackMemoryInfoList = JSON.parse(detailStackMemoryInfoJson.trim());
      }
    } catch (e) {
      console.error(`parse detailStackMemoryInfoJson failed for crashId = ${crashId}`, e);
      message.error('Parse detailStackMemoryInfoJson failed.');
    }

    const pcSymbolModuleInfoList = symbolModuleLines
      .map(x => x.trim())
      .filter(x => x)
      .map(line => {
        const [moduleName, uuid, baseAddressHex = ''] = line.split(/\s/).filter(x => x.trim());
        return { moduleName, uuid, baseAddressHex };
      })
      .filter(x => x.uuid && /^[0-9a-fA-F\-]+$/.test(x.uuid)) // 过滤掉一些没有uuid，或者模块名里面带了空格（比如 (deleted)之类导致上面拆分失败的）
      .map(x => {
        // 安卓/linux minidump：原始uuid对应两个符号表，原始uuid是回溯符号表，uuid + '0'是还原符号表
        if (isAndroid(pid) || isLinux(pid, appId)) {
          return [
            { ...x, minidumpSymbolType: MinidumpSymbolType.UNWIND_INFO, relatedUnwindUuid: x.uuid },
            { ...x, uuid: x.uuid + '0', minidumpSymbolType: MinidumpSymbolType.SYMBOLIC_INFO, relatedUnwindUuid: x.uuid },
          ];
        } else {
          return x;
        }
      })
      .flat();

    const WINE_DLL_NAMES = ['winex11.drv', 'winemac.drv', 'winewayland.drv'];
    const hasWineModuleInAllModuleLines = allModuleLines.some(line => {
      const [moduleName] = (line || '').split(/\t/);
      return WINE_DLL_NAMES.includes((moduleName || '').toLowerCase());
    });
    const hasWineModuleInSymbolModuleList = pcSymbolModuleInfoList.some(item =>
      WINE_DLL_NAMES.includes((item.moduleName || '').toLowerCase())
    );
    const pcHasWineModule = hasWineModuleInAllModuleLines || hasWineModuleInSymbolModuleList;

    return state
      .update('current', (issue) => issue.set('lastFetchedPcSoInfoCrashId', crashId))
      .update('current', (issue) => issue.set('pcModuleInfoList', pcSymbolModuleInfoList))
      .update('current', (issue) => issue.set('pcAllModuleInfoLines', allModuleLines))
      .update('current', (issue) => issue.set('pcHasWineModule', pcHasWineModule))
      .update('current', (issue) => issue.set('minidumpDetailStackMemoryInfoList', minidumpDetailStackMemoryInfoList))
      .update('current', (issue) => issue.set('pcStackMemoryLines', stackMemoryLines));
  },

  PARSE_AND_SAVE_PC_REGISTER_INFO: (state, action) => {
    const { payload } = action;
    const { registerInfoText } = payload;
    const pcRegisterInfoLines = String(registerInfoText || '').split('\n').filter(x => x.trim());
    const minidumpRegisterInfoParseResult = RegisterInfoUtil.parseMinidumpLines(pcRegisterInfoLines);
    return state.update('current', (issue) => issue
      .set('pcRegisterInfoLines', pcRegisterInfoLines)
      .set('minidumpRegisterInfoParseResult', minidumpRegisterInfoParseResult));
  },

  PARSE_AND_SAVE_PC_OTHER_THREADS: (state, action) => {
    const { payload } = action;
    const { otherThreadsText, platformId } = payload;
    // 保持PC/Linux旧解析不变，仅PS5走专用格式解析。
    const otherThreads = isPlaystation(platformId)
      ? parsePlaystationOtherThreads(otherThreadsText)
      : parsePcOtherThreads(otherThreadsText);

    return state.update('current', (issue) => issue.set('otherThread', otherThreads));
    /* PC其他线程格式样例：
Thread(1)
	ntdll.dll	pc 0x14	NtRemoveIoCompletion	(:0)[amd64:Windows NT:1D272E6EB138642C3C71E6089E65E2431]
	mswsock.dll	pc 0x9b	SockAsyncThread	(:0)[amd64:Windows NT:41A36919692661781D0CD5E84885B7B01]
	kernel32.dll	pc 0x1d	BaseThreadInitThunk	(:0)[amd64:Windows NT:7C4E08F45D72C45361D8C89A0278B6991]
	ntdll.dll	pc 0x28	RtlUserThreadStart	(:0)[amd64:Windows NT:1D272E6EB138642C3C71E6089E65E2431]
Thread(2)
	ntdll.dll	pc 0x14	NtWaitForSingleObject	(:0)[amd64:Windows NT:1D272E6EB138642C3C71E6089E65E2431]
	KERNELBASE.dll	pc 0x33f8e		(:0)[amd64:Windows NT:23CC3BB5BB5C6F341F5ADCBF41ADE6A91]
	NGR-Win64-ShippingBase.dll	pc 0xc6b35d		(:0)[amd64:Windows NT:0E33CB77D744411FA7727CF16FD940E81]
	NGR-Win64-ShippingBase.dll	pc 0x26f880		(:0)[amd64:Windows NT:0E33CB77D744411FA7727CF16FD940E81]
	NGR-Win64-ShippingBase.dll	pc 0x26b6a0		(:0)[amd64:Windows NT:0E33CB77D744411FA7727CF16FD940E81]
	NGR-Win64-ShippingBase.dll	pc 0x18f1e4		(:0)[amd64:Windows NT:0E33CB77D744411FA7727CF16FD940E81]
	NGR-Win64-ShippingBase.dll	pc 0x26b6a0		(:0)[amd64:Windows NT:0E33CB77D744411FA7727CF16FD940E81]
	NGR-Win64-ShippingBase.dll	pc 0x2592a5		(:0)[amd64:Windows NT:0E33CB77D744411FA7727CF16FD940E81]
	NGR-Win64-ShippingBase.dll	pc 0xeb2bd0		(:0)[amd64:Windows NT:0E33CB77D744411FA7727CF16FD940E81]
...
    */
  },

  [ReduxActionType.parseAggResultAndSetIssueIdToWangZheTopFormList]: (state, action) => {
    const rsp = action.payload;
    const { bucketList } = rsp.json.data[0] || {};
    const issueIdAndWangZheTopFormListEntries = (bucketList || [])
      .map(x => {
        const { subBucketList, key: issueId, docCount } = x;
        const wangZheTopFormList = (subBucketList || []).map(subBucket => {
          const { key: subKey, docCount: subCount } = subBucket;
          return {
            name: subKey,
            matchedCount: subCount,
            totalCount: docCount,
          };
        });
        return [issueId, wangZheTopFormList];
      });
    const issueIdToWangZheTopFormList = Object.fromEntries(issueIdAndWangZheTopFormListEntries);
    return state.set('issueIdToWangZheTopFormList', issueIdToWangZheTopFormList);
  },
}, initialState);

function handleGetIssueInfoSuccess(state, action) {
  const { response: issueInfo } = action;
  {
    const current = state.get('current');
    const finalIssueInfo = IssueCrashSearchUtil.refineGetIssueInfoResponse(issueInfo);
    const exists = !finalIssueInfo.isIssueNotExists;
    if (exists && current) {
      return state.set('current', current.merge(Immutable.fromJS(finalIssueInfo)));
    } else {
      return state.set('current', Immutable.fromJS(finalIssueInfo));
    }
  }
  console.error('getIssueInfo response issueList must have one element! reponse:', action.response);
  return state;
}

function changeExceptionOptionsAndTypeList(state, pid, exceptionType) {
  let options;
  switch (exceptionType) {
    case 'crashes':
    case 'crash':

      if ( parseInt(pid) === PLATFORM_ID.ANDROID ) {
        options = ANDROID_EXCEPTION_TYPE_LIST_OPTIONS
      } else if ( parseInt(pid) === PLATFORM_ID.IOS ) {
        options = IOS_EXCEPTION_TYPE_LIST_OPTIONS
      } else {
        options = [
          { label: i18n.t('exceptionTypeOptions.所有类型'), value: DEFAULT_EXCEPTION_TYPE_LIST_ANDROID },
        ];
      }
      //options = parseInt(pid) === 1 ? ANDROID_EXCEPTION_TYPE_LIST_OPTIONS : IOS_EXCEPTION_TYPE_LIST_OPTIONS;
      break;
    case 'blocks':
    case 'anr':
      options = ANR_EXCEPTION_TYPE_LIST_OPTIONS;
      break;
    case 'errors':
    case 'error':
      options = ERROR_EXCEPTION_TYPE_LIST_OPTIONS;
      break;
    case 'jank':
      options = JANK_EXCEPTION_TYPE_LIST_OPTIONS;
      break;
    case 'hang':
      options = HANG_EXCEPTION_TYPE_LIST_OPTIONS;
      break;
    case 'metrickit-crash':
      options = METRICKIT_CRASH_EXCEPTION_TYPE_LIST_OPTIONS;
      break;
    case 'metrickit-cpu':
      options = METRICKIT_CPU_EXCEPTION_TYPE_LIST_OPTIONS;
      break;
    case 'metrickit-disk':
      options = METRICKIT_DISK_EXCEPTION_TYPE_LIST_OPTIONS;
      break;
    case 'aexit-crash':
      options = AEXIT_CRASH_EXCEPTION_TYPE_LIST_OPTIONS;
      break;
    case 'aexit-anr':
      options = AEXIT_ANR_EXCEPTION_TYPE_LIST_OPTIONS;
      break;
    default: break;
  }
  return state
    .updateIn(['selectOptions', 'exceptionTypeList'], () => new Map({ options }))
    .updateIn(['searchParams', 'exceptionCategoryList'], () => ExceptionCategoryUtil.unify(exceptionType))  // 这个list是逗号分隔的
}

/**
 * 处理获取issue搜索条件可选项
 */
function handleGetIssueOptions(state, action) {
  const { tags = [], members = [], versions = [] } = action.response;
  return state.update('selectOptions', (options) => options.mergeDeep({
    version: {
      // options: new List(versions).map((item) => ({ label: item.version, value: encodeURIComponent(item.version) })).unshift({
      //  label: '全版本',
      //  value: 'all',
      // }),
      options: (() => {
        const results = [];

        versions.forEach((item) => {
          results.push({
            ...item,
            label: parseInt(item.enable) === 0 ? (`${item.version}(已关闭)`) : item.version,
            value: encodeURIComponent(item.version),
          });
          if (Array.isArray(item.hotpatchVersions) && item.hotpatchVersions.length > 0) {
            item.hotpatchVersions.forEach((hotpatchVersion) => {
              results.push({
                label: parseInt(item.enable) === 0
                  ? (`${item.version}(hotpatch: ${hotpatchVersion})(已关闭)`) : `${item.version}(hotpatch: ${hotpatchVersion})`,
                value: encodeURIComponent(`${item.version}[${hotpatchVersion}]`),
              });
            });
          }
          if (Array.isArray(item.hotPluginVersionBeans) && item.hotPluginVersionBeans.length > 0) {
            item.hotPluginVersionBeans.forEach((pluginVersionBean) => {
              if (Array.isArray(pluginVersionBean.hotPluginVersion) && pluginVersionBean.hotPluginVersion.length > 0) {
                pluginVersionBean.hotPluginVersion.forEach((hotPluginVersion) => {
                  results.push({
                    label: parseInt(item.enable) === 0
                      ? (`${item.version}(plugin: ${pluginVersionBean.hotPluginId}--${hotPluginVersion})(已关闭)`)
                      : `${item.version}(plugin: ${pluginVersionBean.hotPluginId}--${hotPluginVersion})`,
                    value: encodeURIComponent(`${item.version}[${pluginVersionBean.hotPluginId}[${hotPluginVersion}]]`),
                  });
                });
              }
            });
          }
        });
        results.unshift({
          label: i18n.t('versionOptions.全版本'),
          value: 'all',
        });
        return results;
      })(),
    },
    processor: {
      options: new List(uniqBy(members, x => getUserId(x))).map((item) => ({
        label: getNickName(item),
        value: (item || {}).userId,
        localUserId: (item || {}).newUserId,
      })).unshift({ label: i18n.t('processorOptions.所有处理人'), value: 'all' }),
    },
    tagList: {
      options: new List(tags).map((item) => ({ label: item.tagName, value: item.tagId })).unshift({
        label: i18n.t('tagOptions.所有标签'),
        value: 'all',
      }),
    },
  }));
}

function fillPartialNonMinidumpDetailStackMemoryInfoList(nonMinidumpDetailStackMemoryInfoList, pid, { memoryData, retraceCrashDetail }) {
  let res = [...(nonMinidumpDetailStackMemoryInfoList || [])];
  let patchList = [];
  if (memoryData) {
    patchList.push(...memoryData.map((x, i) => ({
      lineNumber: i + 1,
      originAddress: x?.originAddress || '',
      originMemoryData: x?.originMemoryData || '',
      asmCodeInfo: x?.asm || '',
    })));
  }
  if (retraceCrashDetail) {
    const stackLines = StackUtil.splitStackIntoLines(retraceCrashDetail, pid);
    patchList.push(...stackLines.map((x, i) => ({
      lineNumber: i + 1,
      lineStack: x,
    })));
  }

  patchList.forEach(patch => {
    const { lineNumber } = patch;
    const hasMatchedLineNumber = res.some(x => x?.lineNumber === lineNumber);
    if (hasMatchedLineNumber) {
      res = res.map(x => {
        if (x?.lineNumber !== lineNumber) {
          return x;
        }
        return {
          ...x,
          ...patch,
        };
      });
    } else {
      res.push(patch);
    }
  });

  res.sort((a, b) => a.lineNumber - b.lineNumber);
  return res;
}

/**
 * 自定义kv合并需求背景：
 * 移动端的自定义kv数据存放在COS附件（valueMapOthers.txt），由handleGetCrashAttachment解析；
 * PC旧数据/PS5的自定义kv数据存放在ES（crashDoc.esMap.hashKeyValues），由handleGetCrashDoc解析。
 * 原本这两条链路按端"二选一"，互不相关。
 * 现在发现移动端的ES里也会额外存一些COS里没有的自定义kv，因此改为两条链路都解析，最后取并集、按key去重展示。
 * 由于优先取ES的值是为了和搜索功能（依赖ES数据）结果保持一致，所以ES数据在去重时优先保留（uniqBy保留数组里靠前的元素）。
 *
 * 因为两个reducer的触发顺序不确定（不知道ES请求和COS附件请求谁先返回），所以不能在某一个reducer里
 * 直接拿到"另一路当时的最新数据"。这里采用的做法是：ES和COS各自把解析出来的原始结果存到state的
 * _esCustomKvList/_cosAllKvList/_cosCustomKvList这几个中间字段里（每次都是整体覆盖，不是累加，
 * 所以重复触发/重试也是幂等的），然后每次两个reducer执行完自己的解析后，都用state里当前的中间结果
 * （不管是不是自己刚刚写的）重新计算一次完整的合并结果，写回对外的attachCustomKvList/attachAllKvList。
 * 这样无论谁先谁后触发，最终都会得到两边合并后的完整数据，不会出现后触发的一方把先触发的一方的数据覆盖掉的情况。
 *
 * 注意：ES侧解析出来的自定义kv（_esCustomKvList）在构造时已经调用过CustomKvUtil.splitCompositeKv拆分过
 * 组合key，是"最终态"数据，所以它同时被当作ES的all和custom来使用，不需要再单独维护一个"ES未拆分的all"字段。
 * COS侧则不同，_cosAllKvList是未拆分的原始全量kv，_cosCustomKvList才是过滤+拆分后的最终态，
 * 两者结构不同不能互相替代，所以COS需要分别维护两个中间字段。
 * @param esList 优先保留的一侧（当前key去重时优先取这一侧的值）
 * @param cosList 另一侧
 * @param dedupeKeyFn 去重取key的函数，all用x.key，custom用x.keyWithType
 */
function mergeEsAndCosKvList(esList, cosList, dedupeKeyFn) {
  return uniqBy([...(esList || []), ...(cosList || [])], dedupeKeyFn);
}

/**
 * IssueCrashPreview.jsx / IssueRegroupCrashInfoList.jsx 这两个组件没有走redux dispatch，
 * 而是在组件本地直接调用handleGetCrashDoc/handleGetCrashAttachment拼装一份临时state，
 * 并且在切换预览的crash时，是拿上一个crash算出来的current state作为下一个crash的初始值
 * （不会经过resetCrashRelatedInfoInCurrentIssue清空)。
 * 如果不清空自定义kv合并用的中间字段，对于不会触发handleGetCrashAttachment的端（PC/PS），
 * 切换crash时会把上一个crash残留的_cosAllKvList/_cosCustomKvList带入这一个crash的合并结果里，
 * 出现自定义kv串数据的问题。所以这些组件在为新的crash发起请求之前，需要先调用这个方法清空。
 */
function clearCustomKvMergeState(issue) {
  return issue
    .set('_esCustomKvList', null)
    .set('_cosAllKvList', null)
    .set('_cosCustomKvList', null)
    .set('attachCustomKvList', null)
    .set('attachAllKvList', null);
}

// 注意，这里的处理逻辑在IssueCrashPreview那里有用到
function handleGetCrashDoc(state, action) {
  let crashDoc = action.response;
  crashDoc.crashMap = crashDoc.crashMap || {};
  crashDoc.detailMap = crashDoc.detailMap || {};
  let newState = saveResponeToCurrent(state, 'crashDoc', crashDoc);
  const pid = action.params.pid;

  let newNonMinidumpDetailStackMemoryInfoList;
  // 移动端非minidump，为了解析显示反汇编结果，需要填充堆栈内容
  if (isMobile(pid)) {
    const { retraceCrashDetail } = crashDoc.crashMap;
    const nonMinidumpDetailStackMemoryInfoList = newState.get('current').get('nonMinidumpDetailStackMemoryInfoList');
    newNonMinidumpDetailStackMemoryInfoList = fillPartialNonMinidumpDetailStackMemoryInfoList(
      nonMinidumpDetailStackMemoryInfoList, pid, { retraceCrashDetail });
    newState = saveResponeToCurrent(newState, 'nonMinidumpDetailStackMemoryInfoList', newNonMinidumpDetailStackMemoryInfoList);
  }

  // PC旧的数据 / PS5 一直是从esMap里面取自定义kv数据；现在移动端也会额外解析一份ES自定义kv，
  // 和handleGetCrashAttachment（COS）解析出来的自定义kv取并集，因此这里不再按端限制，所有端都解析。
  const { esMap } = crashDoc;
  const hashKeyValues = (esMap || {}).hashKeyValues || {};
  let esCustomKvList = Object.values(hashKeyValues)
    .filter(x => x.originKey)
    .map(x => CustomKvUtil.splitCompositeKv(x.originKey, x.originValue))
    .flat();
  esCustomKvList = uniqBy(esCustomKvList, x => x.keyWithType);

  return newState.update('current', (issue) => {
    // 合并时读取state里COS那一侧当前已有的中间结果（可能还没到达，是null，也可能是之前已经到达的数据）
    const cosAllKvList = issue.get('_cosAllKvList');
    const cosCustomKvList = issue.get('_cosCustomKvList');
    return issue
      .set('_esCustomKvList', esCustomKvList)
      .set('attachAllKvList', mergeEsAndCosKvList(esCustomKvList, cosAllKvList, x => x.key))
      .set('attachCustomKvList', mergeEsAndCosKvList(esCustomKvList, cosCustomKvList, x => x.keyWithType));
  });
}

/**
 * 获得额外数据
 * // 注意，这里的处理逻辑在IssueCrashPreview那里有用到
 */
function handleGetCrashAttachment(state, action) {
  const appId = action.params.appId;
  const pid = action.params.pid;
  if (!pid) {
    message.warn('handleGetCrashAttachment, no pid provided');
  }
  // 获得附件数据，只展示指定的文件
  const attachList = [
    ...(action.response.attachList || []),
    ...(action.response.hmosSecondReportAttachList || []), // 鸿蒙二次上报的附件
  ];
  const showAttachmentList = CrashAttachmentUtil.getKnownAttachmentFilenames();
  const extraFile = attachList.map((attachment) => {
    if (showAttachmentList.indexOf(attachment.fileName) > -1) {
      return attachment.fileName;
    }
    return '';
  }).filter((fileName) => !!fileName);

  // 取出文件名为valueMapOthers.txt的内容，并筛选出C03开头（PC除外）的为用户自定义kv
  const delimiter = isPcOrLinux(pid) ? '\n' : ';';
  const allValueMapTexts = attachList.filter(attach => attach.fileName === 'valueMapOthers.txt')
    .map(attach => attach.content)
    .join(delimiter);
  let attachAllKvList = allValueMapTexts
    .split(delimiter)
    .filter(x => x)
    .map((keyValue) => {
      const kvDelimiter = isPcOrLinux(pid) ? '=' : ':';
      const kv = keyValue.split(kvDelimiter);
      let value = kv[1];
      if (kv.length > 2) { // 用户的value可能带有分隔符
        value = kv.slice(1).join(kvDelimiter);
      }

      // 【【CS】【快手】临时适配自定义kv展示：url decode展示kv数据】
      // https://tapd.woa.com/tapd_fe/20421727/story/detail/1020421727120741477
      if (appId === 'd077d69141' || appId === 'e69e718af7' || appId === '873ba6c530') {
        try {
          value = decodeURIComponent(value);
        } catch (e) {
          // ignore
        }
      }

      const key = kv[0];
      return { type: '-', key, keyWithType: key, value };
    });
  attachAllKvList = uniqBy(attachAllKvList, x => x.key);
  const attachCustomKvList = attachAllKvList
    .filter(x => isPcOrLinux(pid) || /C03/i.test(x.key))
    .map(x => CustomKvUtil.splitCompositeKv(x.key, x.value))
    .flat();

  // 其他线程为type=2的附件,这里attachList和otherThread的内容是一样的东西，只是有的有经过一些过滤的操作而已
  const otherThread = attachList.filter((attachment) => {
    if (parseInt(attachment.fileType) === 2) {
      return true;
    } else {
      return false;
    }
  });

  // 安卓的otherThread是java的，现在新增一个native的
  // 来自trace的更多线程也和这个放在一起
  let androidNativeOtherThreadAttachInfoList = [];
  // false: native更多线程， true：来自trace的线程
  let hasAndroidTraceOtherThreads = true;
  // 检查attachList是否包含stacktrace.zip或stacktracejson.zip，如果包含则说明是native更多线程
  if (attachList.some(attach => attach.fileName === 'stacktrace.zip' || attach.fileName === 'stacktracejson.zip')) {
    hasAndroidTraceOtherThreads = false;
  }
  if (action.response.threadInfos?.length > 0) { // iGame需求，来自trace的更多线程
    androidNativeOtherThreadAttachInfoList = action.response.threadInfos.map(x => {
      const {
        name: threadName,
        stack: stackLineList,
        tid: threadId,
      } = x;

      const fileName = `${threadName}(${threadId})`;
      return {
        fileName,
        content: (stackLineList || []).join('\n'),
        fileType: CrashAttachmentFileType.OTHER_THREAD,
        otherThreadExtraInfo: x,
      }
    });
  } else { // 现在解析stacktrace.zip, stacktracejson.zip的逻辑已经移到后台了，这个else逻辑已经走不到了
    const androidNativeOtherThreadAttach = attachList.find(x => x.fileName === 'stacktrace.zip');
    const androidNativeNewFormatOtherThreadAttach = attachList.find(x => x.fileName === 'stacktracejson.zip');
    if (androidNativeOtherThreadAttach?.content) {
      const content = androidNativeOtherThreadAttach.content;
      try {
        androidNativeOtherThreadAttachInfoList = CrashAttachmentUtil.parseAndroidNativeOtherThreadContent(content);
      } catch (e) {
        console.error('parse stacktrace.zip failed.', e);
        message.error(ze('解析Native更多线程信息失败', 'Parse native other threads failed.'));
      }
    } else if (androidNativeNewFormatOtherThreadAttach?.content) {
      const content = androidNativeNewFormatOtherThreadAttach.content;
      try {
        androidNativeOtherThreadAttachInfoList = CrashAttachmentUtil.parseAndroidNativeNewFormatOtherThreadContent(content);
      } catch (e) {
        console.error('parse stacktracejson.zip failed.', e);
        message.error(ze('解析Native更多线程信息失败', 'Parse native other threads failed.'));
      }
    }
  }

  // 卡顿采样堆栈：部分上报会额外带上jankV2_samples.json附件，代表卡顿期间对指定线程的多次采样堆栈，
  // 采样点已经按堆栈内容做过group by，每个samples item代表一个或多个堆栈相同的采样点（times为这些采样点的时间戳，单位ms）。
  // 内容示例：
  // {
  //   "threadId": 13916,
  //   "samples": [
  //     { "stack": "用\n分隔的多行堆栈", "times": [1784798661202, 1784798661578] }
  //   ]
  // }
  let jankSampleStackInfo = null;
  const jankSampleStackAttach = attachList.find(x => x.fileName === 'jankV2_samples.json');
  if (jankSampleStackAttach?.content) {
    try {
      jankSampleStackInfo = JSON.parse(jankSampleStackAttach.content);
    } catch (e) {
      console.error('parse jankV2_samples.json failed.', e);
      message.error(ze('解析卡顿采样堆栈信息失败', 'Parse jank sample stack info failed.'));
    }
  }

  let newNonMinidumpDetailStackMemoryInfoList;
  // 移动端非minidump，解析反汇编结果
  if (isMobile(pid)) {
    const memoryDataJsonText = attachList.find(attach => attach.fileName === 'memoryData.txt')?.content || '';
    let memoryData = [];
    if (memoryDataJsonText) {
      try {
        memoryData = JSON.parse(memoryDataJsonText);
        const nonMinidumpDetailStackMemoryInfoList = state.get('current').get('nonMinidumpDetailStackMemoryInfoList');
        newNonMinidumpDetailStackMemoryInfoList = fillPartialNonMinidumpDetailStackMemoryInfoList(
          nonMinidumpDetailStackMemoryInfoList, pid, { memoryData });
      } catch (e) {
        console.error(`parse memoryData.txt failed.`, e);
        message.error('Parse memoryData.txt failed.');
      }
    }
  }


  /*
// 填充lua/c++混合堆栈
// 内容示例：
#00 pc 067ed8f8 libUE4.so OnTestCrash (E:/UnrealProjects/Unlua426/Source/Unlua426/Unlua426Character.cpp:188) [armeabi-v7a]
#01 pc 0c2e2c31 libUE4.so luaD_precall (C:/work/UnLua/Plugins/UnLua/Source/ThirdParty/Lua/lua-5.4.3/src/ldo.c:532) [armeabi-v7a]
#02 pc 0c305e85 libUE4.so luaV_execute (C:/work/UnLua/Plugins/UnLua/Source/ThirdParty/Lua/lua-5.4.3/src/lvm.c:1624) [armeabi-v7a]
--- Lua Execution Begin ---
[C]: in field 'OnTestCrash'
[string "../../../Unlua426/Content/Script/MyActor.lua"]:33: in function 'FunctionC'
(...tail calls...)
--- Lua Execution End ---
#03 pc 0c2e2e09 libUE4.so ccall (C:/work/UnLua/Plugins/UnLua/Source/ThirdParty/Lua/lua-5.4.3/src/ldo.c:577) [armeabi-v7a]
#04 pc 0c2e2e33 libUE4.so luaD_callnoyield (C:/work/UnLua/Plugins/UnLua/Source/ThirdParty/Lua/lua-5.4.3/src/ldo.c:595) [armeabi-v7a]
#05 pc 0c2ddd0d libUE4.so f_call (C:/work/UnLua/Plugins/UnLua/Source/ThirdParty/Lua/lua-5.4.3/src/lapi.c:1031) [armeabi-v7a]
#06 pc 0c2e2167 libUE4.so luaD_rawrunprotected (C:/work/UnLua/Plugins/UnLua/Source/ThirdParty/Lua/lua-5.4.3/src/ldo.c:144) [armeabi-v7a]
#07 pc 0c2e3261 libUE4.so luaD_pcall (C:/work/UnLua/Plugins/UnLua/Source/ThirdParty/Lua/lua-5.4.3/src/ldo.c:892) [armeabi-v7a]
#08 pc 0c2ddc33 libUE4.so lua_pcallk (C:/work/UnLua/Plugins/UnLua/Source/ThirdParty/Lua/lua-5.4.3/src/lapi.c:1057) [armeabi-v7a]
#09 pc 067ed734 libUE4.so testcall (E:/UnrealProjects/Unlua426/Source/Unlua426/Unlua426Character.cpp:171) [armeabi-v7a]
#10 pc 0c2e2c31 libUE4.so luaD_precall (C:/work/UnLua/Plugins/UnLua/Source/ThirdParty/Lua/lua-5.4.3/src/ldo.c:532) [armeabi-v7a]
#11 pc 0c305e85 libUE4.so luaV_execute (C:/work/UnLua/Plugins/UnLua/Source/ThirdParty/Lua/lua-5.4.3/src/lvm.c:1624) [armeabi-v7a]
--- Lua Execution Begin ---
[C]: in field 'printStack'
[string "../../../Unlua426/Content/Script/MyActor.lua"]:62: in function 'BlockingDelayImpl'
[string "../../../Unlua426/Content/Script/MyActor.lua"]:52: in function 'BlockingDelay'
--- Lua Execution End ---
#12 pc 0c2e2e09 libUE4.so ccall (C:/work/UnLua/Plugins/UnLua/Source/ThirdParty/Lua/lua-5.4.3/src/ldo.c:577) [armeabi-v7a]
#13 pc 0c2e2e33 libUE4.so luaD_callnoyield (C:/work/UnLua/Plugins/UnLua/Source/ThirdParty/Lua/lua-5.4.3/src/ldo.c:595) [armeabi-v7a]
#14 pc 0c2ddd0d libUE4.so f_call (C:/work/UnLua/Plugins/UnLua/Source/ThirdParty/Lua/lua-5.4.3/src/lapi.c:1031) [armeabi-v7a]
#15 pc 0c2e2167 libUE4.so luaD_rawrunprotected (C:/work/UnLua/Plugins/UnLua/Source/ThirdParty/Lua/lua-5.4.3/src/ldo.c:144) [armeabi-v7a]
#16 pc 0c2e3261 libUE4.so luaD_pcall (C:/work/UnLua/Plugins/UnLua/Source/ThirdParty/Lua/lua-5.4.3/src/ldo.c:892) [armeabi-v7a]
#17 pc 0c2ddc33 libUE4.so lua_pcallk (C:/work/UnLua/Plugins/UnLua/Source/ThirdParty/Lua/lua-5.4.3/src/lapi.c:1057) [armeabi-v7a]
#18 pc 067eaed8 libUE4.so CallLuaFunction (E:/UnrealProjects/Unlua426/Source/Unlua426/Unlua426Character.cpp:303) [armeabi-v7a]
#19 pc 067ebea8 libUE4.so OnFire (E:/UnrealProjects/Unlua426/Source/Unlua426/Unlua426Character.cpp:580) [armeabi-v7a]
#20 pc 067ec680 libUE4.so BeginTouch (E:/UnrealProjects/Unlua426/Source/Unlua426/Unlua426Character.cpp:596) [armeabi-v7a]
*/
  let luaCppStack = '';
  let luaLinesFragmentList = [];
  if (action.response.luaCppStack) {
    // 从luaCppStack中去掉开头的“Combined C++/Lua Stack Trace:”
    luaCppStack = action.response.luaCppStack.trim()
      .replace(/^Combined C\+\+\/Lua Stack Trace:/, '')
      .trim();
    const luaStackLines = luaCppStack.split('\n').map(x => x.trim());
    // 根据上面的示例，把多个--- Lua Execution Begin ---到--- Lua Execution End ---之间的行提取出来（不包括这两个分隔行）。然后填充到luaLinesFragmentList里。luaLinesFragmentList的类型是string[][]。
    for (let i = 0; i < luaStackLines.length; i++) {
      const line = luaStackLines[i];
      if (line.startsWith('--- Lua Execution Begin ---')) {
        const luaLinesFragment = [];
        for (let j = i + 1; j < luaStackLines.length; j++) {
          const line = luaStackLines[j];
          if (line.startsWith('--- Lua Execution End ---')) {
            break;
          }
          luaLinesFragment.push(line);
        }
        luaLinesFragmentList.push(luaLinesFragment);
      }
    }
  }

  let csharpAndUsymStack = action.response.csharpAndUsymStack || '';

  let userLogs = action.response.userLogs;
  // PC平台接口里的userLogs字段没有填充内容，需要从附件里面拿
  if (isPcOrLinux(pid)) {
    const pcUserLogsBase64Text = attachList.find(attach => attach.fileName === 'crashSightLog.log')?.content || '';
    if (pcUserLogsBase64Text) {
      try {
        const pcLogUint8Array = Uint8Array.from(window.atob(pcUserLogsBase64Text), c => c.charCodeAt(0));
        const pcLogText = new TextDecoder().decode(pcLogUint8Array);
        userLogs = (pcLogText || '').split('\n');
      } catch (e) {
        console.error('parse crashSightLog.log failed.', e);
        message.error(ze('解析自定义日志失败', 'Parse CustomLog failed'));
      }
    }
  }

  return state.update('current', (issue) => {
    let res = issue.set('sysLogs', action.response.sysLogs)
      .set('userLogs', userLogs)
      .set('extraFile', extraFile)
      .set('otherThread', otherThread)
      .set('androidNativeOtherThreadAttachInfoList', androidNativeOtherThreadAttachInfoList)
      .set('hasAndroidTraceOtherThreads', hasAndroidTraceOtherThreads)
      .set('jankSampleStackInfo', jankSampleStackInfo)
      .set('luaCppStack', luaCppStack)
      .set('luaLinesFragmentList', luaLinesFragmentList)
      .set('isShowingLuaCppStack', luaLinesFragmentList.length > 0)
      .set('csharpAndUsymStack', csharpAndUsymStack)
      .set('isShowingCsharpAndUsymStack', !!csharpAndUsymStack)
      .set('attachList', attachList)
      .set('appDetailCrashInfo', action.response);

    // 除PS5以外的平台，通过附件拿自定义kv（PS5一直是走ES数据，不使用COS附件里的自定义kv）
    if (!isPlaystation(pid)) {
      // 先把COS这一侧的解析结果存到中间字段，再结合state里ES那一侧当前已有的中间结果
      // （可能还没到达，是null，也可能是之前已经到达的数据）重新计算合并结果
      const esCustomKvList = res.get('_esCustomKvList');
      res = res
        .set('_cosAllKvList', attachAllKvList)
        .set('_cosCustomKvList', attachCustomKvList)
        .set('attachAllKvList', mergeEsAndCosKvList(esCustomKvList, attachAllKvList, x => x.key))
        .set('attachCustomKvList', mergeEsAndCosKvList(esCustomKvList, attachCustomKvList, x => x.keyWithType));
    }

    if (newNonMinidumpDetailStackMemoryInfoList) {
      res = res.set('nonMinidumpDetailStackMemoryInfoList', newNonMinidumpDetailStackMemoryInfoList);
    }
    return res;
  });
}

function handleGetSelector(state, action) {
  // 改成getSelectorDatas的接口调用。
  console.log('handleGetSelector的页面信心', action);
  const {
    tagList = [], processorList = [], versionList = [], channelList = [], bundleIdList = [],
  } = action.response;
  const pid = action.params.platformId;
  return state.update('selectOptions', (options) => options.merge({
    version: {
      // options: new List(versions).map((item) => ({ label: item.version, value: encodeURIComponent(item.version) })).unshift({
      //  label: '全版本',
      //  value: 'all',
      // }),
      options: (() => {
        const results = [];

        versionList.forEach((item) => {
          results.push({
            ...item,
            label: parseInt(item.enable) === 0 ? (`${item.name}(已关闭)`) : item.name,
            value: item.name,
          });
        });
        results.unshift({
          label: i18n.t('versionOptions.全版本'),
          value: 'all',
        });
        return results;
      })(),
    },
    processor: {
      options: new List(uniqBy(processorList, x => getUserId(x))).map((item) => ({
        label: getNickName(item),
        value: (item || {}).userId,
        localUserId: (item || {}).localUserId,
        rtx: (item || {}).rtx,
      })).unshift({ label: i18n.t('processorOptions.所有处理人'), value: 'all' }),
    },
    tagList: {
      options: new List(tagList).map((item) => ({ label: item.tagName, value: item.tagId })).unshift({
        label: i18n.t('tagOptions.所有标签'),
        value: 'all',
      }),
    },
    autoTagList: {// 所有自动标签
      options: new List(tagList).filter((item) => parseInt(item.tagType) === 1).map((item) => ({
        label: item.tagName,
        value: item.tagId,
      })).unshift({
        label: i18n.t('tagOptions.所有自动标签'),
        value: 'all',
      }),
    },
    channelList: {
      options: new List(channelList).map((item) => ({ label: item, value: encodeURIComponent(item) })).unshift({
        label: i18n.t('channelOptions.全渠道'),
        value: 'all',
      }),
    },
    bundleIdList: {
      options: new List(bundleIdList).map((item) => ({ label: item, value: encodeURIComponent(item) })).unshift({
        label: parseInt(pid) === 1 ? i18n.t('bundleOptions.所有应用包名') : i18n.t('bundleOptions.所有BundleId'),
        value: 'all',
      })
        .sort((a, b) => compareBundleId(a.label, b.label)),
    },
  }));
}

/**
 * 是否匹配问题列表的路由
 */
function isMatchIssueRoute(pathname) {
  return pathname && pathname.match(ISSUE_LIST_ROUTE_REGEX);
}


// 1 实现切换当前的attachList的解析和还原状态。
function saveResponeToCurrent(state, key, response) {
  // state, 'stackType', action.stackType
  const current = state.get('current');
  if (current) {
    return state.update('current', (issue) => issue.set(key, response));
  } else {
    return state.set('current', { [key]: response });
  }
}

function getCurrentIssueTagInfoList(issue) {
  const currentTags = issue && issue.get && issue.get('tagInfoList');
  if (currentTags && currentTags.toJS) {
    return currentTags.toJS();
  }
  return Array.isArray(currentTags) ? currentTags : [];
}

function resolveNextTagInfoList(issue, action) {
  const response = action.response;
  const responseTagInfoList = response && typeof response === 'object' ? response.tagInfoList : undefined;
  let nextTagInfoList = Array.isArray(responseTagInfoList)
    ? responseTagInfoList
    : getCurrentIssueTagInfoList(issue);
  if (action.type === 'TAG_DEL_SUCC' && action.params && action.params.tagId != null) {
    const deletedId = Number(action.params.tagId);
    nextTagInfoList = nextTagInfoList.filter(tag => Number(tag.tagId) !== deletedId);
  }
  return nextTagInfoList;
}

function handleAddOrDelTagSucc(state, action) {
  // 在列表页，需把结果存在issueList，在详情页（URL中又issue字段），需要结果存在current
  if (action.params.issueId === -1 || action.params.path === 'advanced-search' || action.params.path === 'advancedSearch') {
    return state;
  }
  const detailPageReg = /crashes|anr|block|error/i;
  // 是否是详情页的请求
  if (detailPageReg.test(action.params.path)) {
    return state.update('current', (issue) => issue.set('tagInfoList', new List(resolveNextTagInfoList(issue, action))));
  }
  const selectedIdx = state.get('issueList').findIndex((issue) => issue.get('issueId') === action.params.issueId);
  if (selectedIdx === -1) {
    return state;
  }
  return state.update('issueList', (issueList) => issueList.update(selectedIdx, (issue) => issue.set('tagInfoList', new List(resolveNextTagInfoList(issue, action)))));
}

function changeStateSucc(state, action) {
  // 直接前端修改转状态结果
  if (action.params.page === 'issueDetail') {
    const noteItem = {
      userId: action.params.userId,
      newUserId: action.params.newUserId,
      note: action.params.note,
      createTime: action.params.createTime,
      issueStatus: action.params.status,
      processors: action.params.processors,
    };
    return state.update('current', (issue) => issue.set('processor', action.params.processors)
      .set('assigneeList', action.params.assigneeWithoutLocalUserIdList)
      .set('status', action.params.status)
      .update('noteList', (noteList = fromJS([])) => noteList.unshift(noteItem)));
  } else if (action.params.page === 'issueList') {
    const issueIdArr = !!action.params.issueIds && action.params.issueIds.split(';');
    return state.update('issueList', (issueList) => {
      return issueList.map((issue) => {
        if (issueIdArr && issueIdArr.indexOf(issue.get('issueId')) !== -1) {
          return issue.set('processor', action.params.processors)
            .set('assigneeList', action.params.assigneeWithoutLocalUserIdList)
            .set('status', action.params.status);
        } else {
          return issue;
        }
      });
    });
  } else {
    return state;
  }
}

export const IssueReducerUtil = Object.freeze({
  handleGetCrashDoc,
  handleGetCrashAttachment,
  clearCustomKvMergeState,
});
